import { useIntl } from 'react-intl';
import { Navigate, Outlet } from 'react-router-dom';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';
import { Title } from '@/components/ui/title';
import { useAuthContext } from '@/contexts/auth-context';
import { useNavigationPaths } from '@/hooks/use-navigation-paths';

import { Tabs } from './tabs';

export function Settings() {
  const intl = useIntl();
  const { isAdmin } = useAuthContext();
  const { dashboardPath } = useNavigationPaths();

  if (!isAdmin) {
    return <Navigate to={dashboardPath} replace />;
  }

  return (
    <main className="relative flex flex-1 flex-col gap-4 px-6 py-2">
      <ErrorStateFallback>
        <Header
          headers={[
            { title: intl.formatMessage({ defaultMessage: 'Settings' }) },
          ]}
        />

        {/* Title and Tabs */}
        <div className="shadow-base flex flex-col gap-4 rounded border-b border-neutral-200 bg-white px-6 pt-5">
          <Title
            title={intl.formatMessage({ defaultMessage: 'Source Settings' })}
          />
          <Tabs />
        </div>

        <Outlet />
      </ErrorStateFallback>
    </main>
  );
}
